<template>
  <div class="fw-normal my1 fs-1"><b>No Premis :</b><br><inertia-link :href="$route('premis.show', data.premis_id)" >{{data.no_premis}}</inertia-link>&nbsp;</div>
  <div class="fw-normal my1 fs-1"><b>Nama :</b><br>{{data.premis_nama}}&nbsp;</div>  
  <div class="fw-normal my1 fs-1"><b>Tarikh :</b><br>{{data.premis_tarikh}}&nbsp;</div>  
  <div class="fw-normal my1 fs-1"><b>No Telefon :</b><br>{{data.premis_no_tel}}&nbsp;</div>  
  <div class="fw-normal my1 fs-1"><b>Emel :</b><br>{{data.premis_emel}}&nbsp;</div>  
  <div class="fw-normal my1 fs-1"><b>Alamat :</b><br>{{data.alamat}} {{data.lkp_poskod}} {{data.lkp_bandar}} {{data.lkp_negeri}}&nbsp;</div>
</template>


<script>
export default {
  name: "Premis",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      form : {},
      resourceurl : 'program',
      datas : {},
      
      }
  },
  methods:{

  },
      
  mounted() {
    
    
  }
}
      

</script>  
